// extracted by mini-css-extract-plugin
export default {"pwaInstallBanner":"InstallBanner_pwaInstallBanner__jCQA4","active":"InstallBanner_active__8HavJ"};